import React, { useCallback, useEffect, useState } from "react";
import debounce from "lodash.debounce";

import { Modal, ModalBody, ModalFooter, Button, Spinner, ModalHeader, Input, Collapse, Card, CardBody, CardHeader } from "reactstrap";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { getAllRetailers as getAllRetailersAction } from "../../ReduxToolkit/Reducers/retailers";
import { updateBrandMatches as updateBrandMatchesAction } from "../../ReduxToolkit/Reducers/brands";

// import EditProfileMatchingSection from "./EditProfileMatchingSection";
// import {
//   // getAllMatchingShowroom as getAllMatchingShowroomAction,
//   // selectBrandById,
//   // updateMatchingResults as updateMatchingResultsAction,
// } from "../../../ReduxToolkit/Reducers/brands";

const EditBrandMatchingModal = ({ open, onClose, selectedTab, onSuccess, matchTotal, matchLoading, totalRetailers, updateBrandMatches, matchingResults, allRetailers, getAllRetailers, loadMore }) => {
  const { id } = useParams();
  const [searchTxt, setSearchTxt] = useState("");
  const [updateMatches, setUpdateMatches] = useState([]);
  const [newMatches, setNewMatches] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [reloadLoading, setReloadLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [isMatchingOpen, setIsMatchingOpen] = useState(false);
  const [isRetailersOpen, setIsRetailersOpen] = useState(false);

  const fetchData = async (_page = 1, _searchTxt = "") => {
    setLoading(true);
    await getAllRetailers(_page, {}, _searchTxt, 40, null, Number(id));
    setLoading(false);
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      setPage(1);
      // onSearch(value)
      fetchData(1, value);
    }, 500),
    []
  );

  const handleSearchChange = (e) => {
    e?.preventDefault();
    const { value } = e.target;
    setSearchTxt(value);
    debouncedSearch(value);
  };

  const handleLoadMore = async () => {
    const nextPage = page + 1;
    setPage(nextPage);

    setReloadLoading(true);
    await getAllRetailers(nextPage, {}, searchTxt, 40);
    setReloadLoading(false);
  };

  useEffect(() => {
    fetchData(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  const handleUpdate = async () => {
    setSubmitLoading(true);
    await updateBrandMatches({
      data: {
        newMatches,
        brand_id: Number(id),
        updates: updateMatches,
        matched_by_ai: selectedTab === 'Matched By AI' || selectedTab === 'Retailers'
      },
      cb: () => {
        onClose();
        onSuccess();
      },
    });
    setSubmitLoading(false);
  };
  return (
    <Modal
      isOpen={open}
      toggle={onClose}
      style={{ maxWidth: "820px" }}
      className="p-3 m-0 m-md-auto modal-custom-width"
    >
      <ModalHeader toggle={onClose}>
        <span
          style={{
            fontSize: "24px",
            fontWeight: "700",
            textTransform: "uppercase",
          }}
        >
          Edit Brand Matches
        </span>
      </ModalHeader>
      <ModalBody
        style={{
          padding: "1rem 2rem",
          maxHeight: "80vh",
          overflow: "auto"
        }}
      >
        <div>
          {/* Matching */}
          <div>
            {matchingResults?.length ? (
              <Card className="mb-3">
                <CardHeader
                  onClick={() => setIsMatchingOpen(!isMatchingOpen)}
                  style={{
                    cursor: 'pointer',
                    backgroundColor: '#f8f9fa',
                    border: 'none',
                    padding: '1rem'
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <h6 style={{ fontSize: '17px', fontWeight: 'bold', margin: 0 }}>
                      Matching ({matchTotal})
                    </h6>
                    <span style={{ fontSize: '18px' }}>
                      {isMatchingOpen ? '−' : '+'}
                    </span>
                  </div>
                </CardHeader>
                <Collapse isOpen={isMatchingOpen}>
                  <CardBody style={{ padding: '1rem' }}>
                    {matchingResults?.map((item, i) => {
                      const selected = updateMatches?.find((m) => m?.retailer_id === item?.id);

                      const handleGradeChange = (e) => {
                        const { value } = e.target;

                        let newMatches = [...updateMatches];

                        if (selected) {
                          newMatches = newMatches.map((m) => {
                            if (m?.retailer_id === item?.id) {
                              return { ...m, grade: value };
                            }
                            return m;
                          });
                        } else {
                          newMatches.push({ retailer_id: item?.id, grade: value });
                        }

                        setUpdateMatches(newMatches);
                      }

                      const handleMatchRateChange = (e) => {
                        const { value } = e.target;

                        let newMatches = [...updateMatches];

                        if (selected) {
                          newMatches = newMatches.map((m) => {
                            if (m?.retailer_id === item?.id) {
                              return { ...m, final_match_rate: Number(value) };
                            }
                            return m;
                          });
                        } else {
                          newMatches.push({ retailer_id: item?.id, final_match_rate: Number(value) });
                        }

                        setUpdateMatches(newMatches);
                      }

                      const handlePriorityChange = (e) => {
                        const { value } = e.target;

                        let newMatches = [...updateMatches];

                        if (selected) {
                          newMatches = newMatches.map((m) => {
                            if (m?.retailer_id === item?.id) {
                              return { ...m, priority: value };
                            }
                            return m;
                          });
                        } else {
                          newMatches.push({ retailer_id: item?.id, priority: value });
                        }

                        setUpdateMatches(newMatches);
                      }

                      const handleCheckboxChange = (e) => {
                        const { checked } = e.target;

                        let newMatches = [...updateMatches];

                        if (selected) {
                          newMatches = newMatches.map((m) => {
                            if (m?.retailer_id === item?.id) {
                              return { ...m, deleted: !checked };
                            }
                            return m;
                          });
                        } else {
                          newMatches.push({ retailer_id: item?.id, deleted: !checked });
                        }

                        setUpdateMatches(newMatches);
                      }


                      return (
                        <div key={i} className="mb-3" style={{ padding: '10px 0px', borderBottom: '1px solid #e9ecef' }}>
                          <div className="d-flex justify-content-between align-items-start">
                            <div className="d-flex align-items-center justify-content-start text-start" style={{ gap: "0.5rem", flex: 1 }}>
                              <p style={{
                                fontSize: "14px",
                                color: "#757575",
                                maxWidth: "250px",
                                fontWeight: 500,
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                WebkitLineClamp: 2,
                                margin: 0
                              }}>
                                {item?.name || "--"}
                              </p>
                              {item?.matched_by_ai ? (
                                <span
                                  className="d-none d-md-inline"
                                  style={{ fontSize: "12px", fontWeight: 600, color: "#2A9FDF" }}
                                >
                                  Added by AI
                                </span>
                              ) : null}
                            </div>
                            <div className="d-flex align-items-center" style={{ gap: "0.5rem" }}>
                              <Input
                                type="checkbox"
                                checked={!(selected?.deleted)}
                                onChange={handleCheckboxChange}
                                style={{ transform: "scale(1.2)" }}
                              />
                            </div>
                          </div>

                          <div className="mt-2 d-flex flex-wrap align-items-center" style={{ gap: "1rem" }}>
                            <div className="d-flex align-items-center" style={{ gap: "0.5rem" }}>
                              <span style={{ fontSize: "13px", fontWeight: 600, color: "#495057" }}>Grade:</span>
                              <Input type="radio" name={`grade-${i}`} disabled={selected?.deleted} value="A+" checked={(selected?.grade !== undefined ? selected?.grade : item?.final_grade) === 'A+'} onChange={handleGradeChange} /> A+
                              <Input type="radio" name={`grade-${i}`} disabled={selected?.deleted} value="A" checked={(selected?.grade !== undefined ? selected?.grade : item?.final_grade) === 'A'} onChange={handleGradeChange} /> A
                              <Input type="radio" name={`grade-${i}`} disabled={selected?.deleted} value="B" checked={(selected?.grade !== undefined ? selected?.grade : item?.final_grade) === 'B'} onChange={handleGradeChange} /> B
                              <Input type="radio" name={`grade-${i}`} disabled={selected?.deleted} value="C" checked={(selected?.grade !== undefined ? selected?.grade : item?.final_grade) === 'C'} onChange={handleGradeChange} /> C
                              <Input type="radio" name={`grade-${i}`} disabled={selected?.deleted} value="D" checked={(selected?.grade !== undefined ? selected?.grade : item?.final_grade) === 'D'} onChange={handleGradeChange} /> D
                            </div>

                            {selectedTab === 'Matched By AI' && (
                              <>
                                <div className="d-flex align-items-center" style={{ gap: "0.5rem" }}>
                                  <span style={{ fontSize: "13px", fontWeight: 600, color: "#495057" }}>Match Rate:</span>
                                  <Input
                                    type="select"
                                    disabled={selected?.deleted}
                                    value={selected?.final_match_rate !== undefined ? selected?.final_match_rate : item?.final_match_rate || 50}
                                    onChange={handleMatchRateChange}
                                    style={{ width: "80px", padding: "0.25rem 0.5rem", fontSize: "13px" }}
                                  >
                                    {[...Array(10)].map((_, idx) => {
                                      const value = (idx + 1) * 10;
                                      return <option key={value} value={value}>{value}%</option>;
                                    })}
                                  </Input>
                                </div>

                                <div className="d-flex align-items-center" style={{ gap: "0.5rem" }}>
                                  <span style={{ fontSize: "13px", fontWeight: 600, color: "#495057" }}>Priority:</span>
                                  <div className="d-flex align-items-center" style={{ gap: "0.3rem" }}>
                                    <Input type="radio" name={`priority-${i}`} disabled={selected?.deleted} value="P1" checked={(selected?.priority !== undefined ? selected?.priority : item?.priority) === 'P1'} onChange={handlePriorityChange} /> P1
                                    <Input type="radio" name={`priority-${i}`} disabled={selected?.deleted} value="P2" checked={(selected?.priority !== undefined ? selected?.priority : item?.priority) === 'P2'} onChange={handlePriorityChange} /> P2
                                    <Input type="radio" name={`priority-${i}`} disabled={selected?.deleted} value="P3" checked={(selected?.priority !== undefined ? selected?.priority : item?.priority) === 'P3'} onChange={handlePriorityChange} /> P3
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      );
                    })}
                    
                    {matchingResults?.length < matchTotal && (
                      <div className="mt-3 d-flex justify-content-center">
                        <Button onClick={loadMore} color="primary" disabled={matchLoading}>
                          {matchLoading ? "Loading..." : "Load More"}
                        </Button>
                      </div>
                    )}
                  </CardBody>
                </Collapse>
              </Card>
            ) : null}


            {/* All Retailers */}
            <Card className="mb-3">
              <CardHeader
                onClick={() => setIsRetailersOpen(!isRetailersOpen)}
                style={{
                  cursor: 'pointer',
                  backgroundColor: '#f8f9fa',
                  border: 'none',
                  padding: '1rem'
                }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <h6 style={{ fontSize: '17px', fontWeight: 'bold', margin: 0 }}>
                    All Retailers ({totalRetailers || 0})
                  </h6>
                  <span style={{ fontSize: '18px' }}>
                    {isRetailersOpen ? '−' : '+'}
                  </span>
                </div>
              </CardHeader>
              <Collapse isOpen={isRetailersOpen}>
                <CardBody style={{ padding: '1rem' }}>
                  <Input
                    type="text"
                    placeholder="Search"
                    value={searchTxt}
                    onChange={handleSearchChange}
                  />
                  {loading && (
                    <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
                      <Spinner />
                    </div>
                  )}
                  {!loading && allRetailers?.map((item, i) => {
                    const isInmatchResults = matchingResults?.find((m) => m?.id === item?.id);
                    const isInNewMatches = newMatches?.find((m) => m?.retailer_id === item?.id);

                    if (isInmatchResults) return null;

                    const handleNewMatchCheckboxChange = (e) => {
                      const { checked } = e.target;

                      if (checked) {
                        const defaultMatch = { retailer_id: item?.id, grade: 'A' };
                        if (selectedTab === 'Matched By AI') {
                          defaultMatch.final_match_rate = 50;
                          defaultMatch.priority = 'P2';
                        }
                        setNewMatches((prev) => [...prev, defaultMatch]);
                      } else {
                        setNewMatches((prev) => prev.filter((m) => m?.retailer_id !== item?.id));
                      }
                    };

                    const handleNewMatchGradeChange = (e) => {
                      const { value } = e.target;

                      setNewMatches((prev) => prev.map((m) => {
                        if (m?.retailer_id === item?.id) {
                          return { ...m, grade: value };
                        }
                        return m;
                      }));
                    };

                    const handleNewMatchRateChange = (e) => {
                      const { value } = e.target;

                      setNewMatches((prev) => prev.map((m) => {
                        if (m?.retailer_id === item?.id) {
                          return { ...m, final_match_rate: Number(value) };
                        }
                        return m;
                      }));
                    };

                    const handleNewPriorityChange = (e) => {
                      const { value } = e.target;

                      setNewMatches((prev) => prev.map((m) => {
                        if (m?.retailer_id === item?.id) {
                          return { ...m, priority: value };
                        }
                        return m;
                      }));
                    };

                    return (
                      <div key={i} className="mb-3" style={{ padding: '10px 0px', borderBottom: '1px solid #e9ecef' }}>
                        <div className="d-flex justify-content-between align-items-start">
                          <div className="d-flex align-items-center justify-content-start text-start" style={{ gap: "0.5rem", flex: 1 }}>
                            <p style={{
                              fontSize: "14px",
                              color: "#757575",
                              maxWidth: "250px",
                              fontWeight: 500,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              WebkitLineClamp: 2,
                              margin: 0
                            }}>
                              {item?.name || "--"}
                            </p>
                          </div>
                          <div className="d-flex align-items-center" style={{ gap: "0.5rem" }}>
                            <Input
                              type="checkbox"
                              checked={Boolean(isInNewMatches)}
                              onChange={handleNewMatchCheckboxChange}
                              style={{ transform: "scale(1.2)" }}
                            />
                          </div>
                        </div>
                        {isInNewMatches && (
                          <div className="mt-2 d-flex flex-wrap align-items-center" style={{ gap: "1rem" }}>
                            <div className="d-flex align-items-center" style={{ gap: "0.5rem" }}>
                              <span style={{ fontSize: "13px", fontWeight: 600, color: "#495057" }}>Grade:</span>
                              <Input type="radio" name={`new-grade-${i}`} value="A+" checked={isInNewMatches?.grade === 'A+'} onChange={handleNewMatchGradeChange} /> A+
                              <Input type="radio" name={`new-grade-${i}`} value="A" checked={isInNewMatches?.grade === 'A'} onChange={handleNewMatchGradeChange} /> A
                              <Input type="radio" name={`new-grade-${i}`} value="B" checked={isInNewMatches?.grade === 'B'} onChange={handleNewMatchGradeChange} /> B
                              <Input type="radio" name={`new-grade-${i}`} value="C" checked={isInNewMatches?.grade === 'C'} onChange={handleNewMatchGradeChange} /> C
                              <Input type="radio" name={`new-grade-${i}`} value="D" checked={isInNewMatches?.grade === 'D'} onChange={handleNewMatchGradeChange} /> D
                            </div>

                            {selectedTab === 'Matched By AI' && (
                              <>
                                <div className="d-flex align-items-center" style={{ gap: "0.5rem" }}>
                                  <span style={{ fontSize: "13px", fontWeight: 600, color: "#495057" }}>Match Rate:</span>
                                  <Input
                                    type="select"
                                    value={isInNewMatches?.final_match_rate || 50}
                                    onChange={handleNewMatchRateChange}
                                    style={{ width: "80px", padding: "0.25rem 0.5rem", fontSize: "13px" }}
                                  >
                                    {[...Array(10)].map((_, idx) => {
                                      const value = (idx + 1) * 10;
                                      return <option key={value} value={value}>{value}%</option>;
                                    })}
                                  </Input>
                                </div>

                                <div className="d-flex align-items-center" style={{ gap: "0.5rem" }}>
                                  <span style={{ fontSize: "13px", fontWeight: 600, color: "#495057" }}>Priority:</span>
                                  <div className="d-flex align-items-center" style={{ gap: "0.3rem" }}>
                                    <Input type="radio" name={`new-priority-${i}`} value="P1" checked={isInNewMatches?.priority === 'P1'} onChange={handleNewPriorityChange} /> P1
                                    <Input type="radio" name={`new-priority-${i}`} value="P2" checked={isInNewMatches?.priority === 'P2'} onChange={handleNewPriorityChange} /> P2
                                    <Input type="radio" name={`new-priority-${i}`} value="P3" checked={isInNewMatches?.priority === 'P3'} onChange={handleNewPriorityChange} /> P3
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}

                  {/* Load More Button */}
                  <div className="mt-3 d-flex justify-content-center">
                    {allRetailers?.length ? (
                      <Button onClick={handleLoadMore} color="primary" disabled={reloadLoading}>
                        {reloadLoading ? "Loading..." : "Load More"}
                      </Button>
                    ) : null}
                  </div>
                </CardBody>
              </Collapse>
            </Card>
          </div>
        </div>

      </ModalBody>
      <ModalFooter className="d-flex justify-content-end" style={{ padding: "1rem 1rem" }}>
        <Button color="primary" size="md" style={{ borderRadius: "40px", padding: "0.75rem 2rem" }} onClick={handleUpdate}>
          {submitLoading ? <Spinner size="sm" color="light" /> : "UPDATE PROFILE"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  const data = state.retailers?.allRetailers;
  const flattenData = Object.values(data || {}).flat();

  return {
    allRetailers: flattenData,
    totalRetailers: state.retailers.totalRetailers,
    matchingResults: state.matches?.matchItems,
    matchTotal: state.matches?.matchTotal,
    matchLoading: state.matches?.matchLoading,
  };
};


const mapDispatchToProps = {
  updateBrandMatches: updateBrandMatchesAction,
  getAllRetailers: getAllRetailersAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditBrandMatchingModal);
